import { getBearerToken } from '@/context/TrackOticAuthContext';
const API_BASE = process.env.REACT_APP_BACKEND_URL;

async function req(path, options = {}) {
  const token = getBearerToken();
  const res = await fetch(`${API_BASE}/api/admin${path}`, {
    credentials: 'include',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try { const j = await res.json(); detail = typeof j.detail === 'string' ? j.detail : JSON.stringify(j.detail); } catch { /* noop */ }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res;
}

export const adminGet = (path) => req(path).then(r => r.json());
export const adminPost = (path, body) => req(path, { method: 'POST', body: JSON.stringify(body || {}) }).then(r => r.json());
export const adminPut = (path, body) => req(path, { method: 'PUT', body: JSON.stringify(body || {}) }).then(r => r.json());
export const adminPatch = (path, body) => req(path, { method: 'PATCH', body: JSON.stringify(body || {}) }).then(r => r.json());
export const adminPostBlob = (path, body) => req(path, { method: 'POST', body: JSON.stringify(body || {}) }).then(r => r.blob());
export const adminGetBlob = (path) => req(path).then(r => r.blob());

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}
